export enum SegmentoProduto {
  Saude = 1,
  Odontologico = 2,
  ValeAlimentacao = 3,
  ValeRefeicao = 4,
  Vida = 5,
}
